export default {
  methods: {
    decimalPattern(value) {
      return parseFloat(value).toFixed(1);
    },
  },
};
